import { connect } from 'react-redux'

import { createCustomField, fetchCustomFields, updateCustomField , reorderCustomField} from 'src/legacy/redux/actions/customFields.jsx';

import CustomFieldView from './CustomFieldView.jsx';
import hasAccess from '../../../services/hasAccess.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';


import {trackAdoptionMetricsForCustomFieldClickedEvent,trackAdoptionMetricsForCustomFieldCreatedevent} from "src/legacy/redux/actions/adoption"
const mapStateToProps = (state, ownProps) => {
  return {
    customFields: state.legacyRootReducer.settings.customFields.items,
    loading: state.legacyRootReducer.settings.customFields.loading,
    creating: state.legacyRootReducer.settings.customFields.creating,
    updating: state.legacyRootReducer.settings.customFields.updating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomFields: () => {
      return dispatch(fetchCustomFields());
    },

    createCustomField: (request) => {
      return dispatch(createCustomField(request));
    },

    updateCustomField:(id, request) => {
      return dispatch(updateCustomField(id, request));
    },
    reorderCustomField: (request) => {
      return dispatch(reorderCustomField(request));
  },


  trackAdoptionMetricsForCustomFieldClickedEvent: () =>{
    return dispatch(trackAdoptionMetricsForCustomFieldClickedEvent());
  },
  trackAdoptionMetricsForCustomFieldCreatedevent: (fieldName,helpText,values,isMultiSelectAllowed,isShowInSearchPage) =>{
    return dispatch(trackAdoptionMetricsForCustomFieldCreatedevent(fieldName,helpText,values,isMultiSelectAllowed,isShowInSearchPage));
  }
}
}

const CustomFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFieldView)

export default hasAccess(withUseHooks(CustomFieldContainer), 'custom-fields');